/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import withModal from '../../Modal/WithModal';
import { getOauthUrl } from '../../../ajax/endpoints';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import { activateModal } from '../../../store/actions';

import './FirstTimeFavoriteModal.css';

export const favoritesTypePropLookup = {
  states: 'state',
  regions: 'region',
  counties: 'county',
  communities: 'community',
};

export function withStringIds(WrappedComponent) {
  function WithStringIds({ items, ...props }) {
    return (
      <WrappedComponent
        {...props}
        items={items.map(item => ({ ...item, _id: item._id.toString() }))}
      />
    );
  }

  WithStringIds.displayName = `withStringIds(${WrappedComponent.displayName || WrappedComponent.name})`;

  WithStringIds.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
    })).isRequired,
  };

  return WithStringIds;
}

export class FirstTimeFavoriteModalComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onFolderManagerStateChange = this.onFolderManagerStateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  componentWillMount() {
    const {
      autoAction,
    } = this.props;

    if (autoAction) {
      this.handleAction();
    }
  }

  onFolderManagerStateChange(state) {
    this.setState(state);
  }

  onLogin() {
    if (window.self !== window.top) {
      window.open(getOauthUrl('google'));
    } else {
      window.location = getOauthUrl('google');
    }
  }

  handleAction() {
    const {
      saveItems,
      removeItems,
      items,
      itemType,
      folderId,
      action,
      onModalClick,
    } = this.props;
    const fn = action === 'save' ? saveItems : removeItems;
    fn({ items, itemType, folderId });
    onModalClick();
  }

  handleSubmit(e) {
    e.preventDefault();
    this.handleAction();
  }

  render() {
    const {
      onModalClick,
      dontShowAgain,
      dontShow,
      addFavoriteAfterClose,
      onContinue,
    } = this.props;

    return (
      <div className="first-time-modal">
        <div className="first-time-modal__header">
          <h2 className="first-time-modal__title">You are not logged into favorites</h2>
          <a tabIndex="0" onClick={onModalClick}>
            <div className="first-time-modal__close">
              X
            </div>
          </a>
        </div>
        <div className="first-time-modal__body">
          <p>
            Your property list will only be saved on this device.
            To save your lists for future use, please login.
          </p>
          <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
            <button
              style={{ marginRight: 10 }}
              className="btn"
              type="button"
              onClick={this.onLogin}
            >
              Log In
            </button>
          </ViewerPrimaryColorUserStyle>
          <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
            <button
              style={{ marginRight: 10 }}
              className="btn"
              type="button"
              onClick={() => {
                onModalClick();
                addFavoriteAfterClose();
                if (typeof onContinue === 'function') {
                  onContinue();
                }
              }}
            >
              Continue Without Logging In
            </button>
          </ViewerPrimaryColorUserStyle>
          <div className="first-time-modal__checkbox">
            <input onChange={dontShow} id="id" type="checkbox" checked={dontShowAgain} />
            <label htmlFor="id">Do not display this message again</label>
          </div>
        </div>
      </div>
    );
  }
}

FirstTimeFavoriteModalComponent.propTypes = {
  action: PropTypes.oneOf(['save', 'remove']).isRequired,
  folderId: PropTypes.string,
  autoAction: PropTypes.bool,
  saveItems: PropTypes.func,
  removeItems: PropTypes.func,
  onModalClick: PropTypes.func,
  addFavoriteAfterClose: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
  })).isRequired,
  itemType: PropTypes.string.isRequired,
  dontShow: PropTypes.func,
  dontShowAgain: PropTypes.bool,
  onContinue: PropTypes.func,
};

export function mapStateToProps({ favorites, profile }, { favoritesType, ...props }) {
  const item = props[favoritesTypePropLookup[favoritesType]];
  const id = item && item._id ? item._id.toString() : 'missing';
  return {
    id,
    saved: favorites.folders.savedFolders
      .some(folder => (folder[favoritesType] || []).indexOf(id) !== -1),
  };
}

export function mapDispatchToProps(dispatch, { ...props }) {
  const id = props.id;
  return {
    addFavoriteAfterClose: () => (id ? dispatch(activateModal(`folders-${id}`)) : dispatch(activateModal('folders'))),
  };
}

export function mergeProps(propsFromState, propsFromDispatch, ownProps) {
  return {
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps,
  };
}
export default withStringIds(withModal(connect(mapStateToProps, mapDispatchToProps, mergeProps)(FirstTimeFavoriteModalComponent), 'first-time'));



// WEBPACK FOOTER //
// ./src/components/Favorites/FirstTimeFavoriteModal/FirstTimeFavoriteModal.js